
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/web/searx",
      function () {
        return require("private-next-pages/web/searx/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/web/searx"])
      });
    }
  